// Self-hosted fonts (Fontsource). These register the `Inter Variable` /
// `Space Grotesk Variable` families the theme's stacks name; see theme/typography.ts.
import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { installChunkReloadHandler } from './routes/chunk-reload';
import { initSentry } from './sentry';

// Initialize Sentry as early as possible
initSentry();

// Recover from stale lazy-chunk loads after a deploy (see chunk-reload.ts).
installChunkReloadHandler();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Check index.html for <div id="root">.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
